import { graphql } from "../gql";

export const deleteSsoDomainIdentityProviderMutationDoc = graphql(`
  mutation deleteSsoDomainIdentityProvider(
    $input: DeleteSsoDomainIdentityProviderInput!
  ) {
    deleteSsoDomainIdentityProvider(input: $input) {
      ssoDomainIdentityProvider {
        id
        __typename
      }
    }
  }
`);
